import axios from 'axios';

const API_URL = 'https://huongtramcomoc.vn/api/endpoints/';

const createOrder = (formData) => {
  return axios.post(API_URL + 'create_order.php', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
const lookupOrder = (name, phone) => {
  return axios.post(API_URL + 'lookup_order.php', {
    name: name,
    phone: phone
  });
};
const getPublicOrderDetails = (id, phone) => {
  return axios.post(API_URL + 'get_public_order_details.php', {
    id: id,
    phone: phone
  });
};
const cancelOrder = (orderId, phone) => {
  return axios.post(API_URL + 'cancel_order.php', {
    order_id: orderId,
    phone: phone
  });
};
const orderService = {
  createOrder,
  lookupOrder,
  getPublicOrderDetails,
  cancelOrder,
};

export default orderService;